import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MedicalApplications.css';

const MedicalApplications = () => {
    const navigate = useNavigate();
    const baseUrl = 'https://sakthivel.ascentbw.com/Files/Home/';

    const medicalItems = [
        {
            title: "Surgical Implant Component",
            desc: "High-precision medical grade implant component designed for surgical applications.",
            img: `${baseUrl}Product1.png`
        },
        {
            title: "Precision Medical Housing",
            desc: "Custom machined housing for sensitive medical diagnostic equipment.",
            img: `${baseUrl}Product2.png`
        },
        {
            title: "Orthopedic Fixation Part",
            desc: "Durable and bio-compatible fixation part for orthopedic surgeries.",
            img: `${baseUrl}Product3.png`
        },
        {
            title: "Surgical Instrument Component",
            desc: "Precision-engineered part for advanced surgical instrumentation.",
            img: `${baseUrl}Product4.png`
        },
        {
            title: "Medical Device Bracket",
            desc: "Stable and accurate mounting bracket for medical devices.",
            img: `${baseUrl}Product5.png`
        },
        {
            title: "High-Precision Guide Pin",
            desc: "Ultra-precise guide pin for surgical alignment and support.",
            img: `${baseUrl}Product6.png`
        },
        {
            title: "Bio-Machined Component",
            desc: "Specialized machined component using bio-compatible materials.",
            img: `${baseUrl}Product7.png`
        },
        {
            title: "Specialized Surgical Tool",
            desc: "Custom manufactured tool for specific surgical requirements.",
            img: `${baseUrl}Product8.png`
        },
        {
            title: "Bio-Compatible Titanium Part",
            desc: "Advanced titanium component for long-term medical implants.",
            img: `${baseUrl}Product9.png`
        },
        {
            title: "Endoscopic Tool Handle",
            desc: "Ergonomic and sterilizable handle for endoscopic surgical tools.",
            img: `${baseUrl}Product10.png`
        },
    ];


    return (
        <section id="medical-section" className="medical-section">
            <div className="container">
                <div className="medical-header">
                    <div className="medical-header-left">
                        <h2 className="medical-title">
                            Medical Components <br />
                            We Deliver
                        </h2>
                    </div>
                    <div className="medical-header-right">
                        <button 
                            className="medical-quote-btn" 
                            onClick={() => navigate('/products', { state: { category: 'medical' } })}
                        >
                            VIEW MEDICAL COMPONENTS
                        </button>
                        <p className="medical-header-desc">
                            We manufacture high-precision components for medical and surgical use, 
                            ensuring accuracy, reliability, and consistent quality.
                        </p>
                    </div>
                </div>

            </div>
            <div className="medical-slider-wrapper">
                <div className="medical-slider-track">
                    {[...medicalItems, ...medicalItems].map((item, index) => (
                        <div key={index} className="medical-card slider-item">
                            <div className="card-image-box">
                                <img src={item.img} alt={item.title} title={item.title} />
                            </div>
                            <div className="card-content">
                                <h4 className="card-title">{item.title}</h4>
                                <p className="card-desc">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="medical-stats-container">
                <div className="container">
                    <div className="medical-stats-grid">
                        <div className="medical-stat-card">
                            <span className="stat-label">Medical Components Delivered</span>
                            <h3 className="stat-value">25K+</h3>
                        </div>
                        <div className="medical-stat-card">
                            <span className="stat-label">Years Of Experience</span>
                            <h3 className="stat-value">20+</h3>
                        </div>
                        <div className="medical-stat-card">
                            <span className="stat-label">Custom Projects Completed</span>
                            <h3 className="stat-value">500+</h3>
                        </div>
                        <div className="medical-stat-card">
                            <span className="stat-label">Quality Compliance</span>
                            <h3 className="stat-value">100%</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MedicalApplications;
